var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocateLogoSmall({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 30,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#111",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.43 17.305A13.12 13.12 0 0 0 24.675 8L20.9 11.775l5.53 5.53zM26 19l-6.16-6.17L16.66 16c.234.434.281.945.13 1.415l6.395 6.41A13.135 13.135 0 0 0 26 19zM13.25 16 11 13.74a1.905 1.905 0 0 1-2.28-2.28L3.565 6.32A13.115 13.115 0 0 0 .87 11.275l9.275 9.28 3-3a1.845 1.845 0 0 1 .1-1.55L13.25 16zM.35 14.93A13.075 13.075 0 0 0 3 22.835a4.2 4.2 0 0 1 5.11-.24l1-1L.5 13a13.261 13.261 0 0 0-.15 1.93zM11.285 10.1l5.345-5.345a3.325 3.325 0 0 1-.395-2.685 13.135 13.135 0 0 0-11.63 3.175l5 5a1.87 1.87 0 0 1 1.69-.135l-.01-.01zM22.115 5a3.355 3.355 0 0 1-4.53.76L12.3 11.055c.28.574.245 1.252-.09 1.795l2.195 2.195c.395-.13.823-.117 1.21.035l1.79-1.79 1.45-1.45 5-5A13.185 13.185 0 0 0 22.115 5zM22.11 24.865l-6.275-6.275c-.55.296-1.21.296-1.76 0l-1.5 1.5-1.45 1.45L9.1 23.565a4.175 4.175 0 0 1 .56 3.935 13.12 13.12 0 0 0 12.45-2.64v.005z"
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-20.92 14.98 16.9)",
    cx: 14.981,
    cy: 16.899,
    r: 1.065
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-20.92 10.599 11.884)",
    cx: 10.599,
    cy: 11.884,
    r: 1.065
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-20.92 5.74 26.06)",
    cx: 5.741,
    cy: 26.06,
    r: 2.885
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-20.92 19.393 3.041)",
    cx: 19.393,
    cy: 3.041,
    r: 1.98
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocateLogoSmall);
export default __webpack_public_path__ + "static/media/locate-logo-small.e49d6d7d.svg";
export { ForwardRef as ReactComponent };